function createRequest(poi) {
    const apiCodes = {
        yes: "GREEN",
        designated: "GREEN",
        limited: "YELLOW",
        no: "RED",
        "": "GREY",
    };
    const details = poi.tags["wheelchair:description"] || "";
    const preferredAccessibility = apiCodes[poi.tags.wheelchair || ""];
    const toiletPreferredAccessibility =
        apiCodes[poi.tags["toilets:wheelchair"] || ""];
    return { details, preferredAccessibility, toiletPreferredAccessibility };
}

export async function savePoiAccessibility(poi) {
    var request = createRequest(poi);
    const options = {
        service:
            "poi/" + poi.type.toUpperCase() + "/" + poi.id + "/accessibility",
        request: request,
        lang: "en",
    };
    console.log(options);

    return "success";
    /* 
	try {
		const data = await apiCall(options);
		console.log('sikeres mentés');
		console.log(data);
		return;
	} catch (err) {
		console.log(err);
	} finally {
		console.log('finished');
	} */
}
